
const SERVICE_WORKER_FILE = "service-worker.js";

export class ServiceWorkerService {

    public static id = "serviceWorkerService";

    private swSupported = false;
    private _registration: Promise<ServiceWorkerRegistration>;

    public constructor() {
        this.init();
    }

    private init() {
        this.swSupported = "serviceWorker" in navigator;
        if (this.swSupported) {
            this.registerWorker();
        }
    }

    public get supported(): boolean {
        return this.swSupported;
    }

    private async registerWorker(): Promise<ServiceWorkerRegistration> {
        if (this._registration == null && this.supported) {
            navigator.serviceWorker.register(SERVICE_WORKER_FILE);
            this._registration = navigator.serviceWorker.ready;
        }
        return this._registration;
    }

    public async registration(): Promise<ServiceWorkerRegistration> {
        if (this.supported) {
            return this._registration;
        } else {
            throw Error("Service Worker is not supported");
        }
    }
}
